// Prod_US (SeniorLife Mobility): fixed settings. Spec: SeniorLife-Mobility-Prod_US-v1.0.html.
import { STS_MODULE_ID } from "../../utlis/measurementModules";

export const PROD_US_CUSTOMER_TYPE = "prod_us";

// Both tests, always together, in this order: Sit-to-Stand (Side), then TUG (Front).
export const TUG_FRONT_MODULE_ID = 4;
export const PROD_US_MODULE_IDS = [STS_MODULE_ID, TUG_FRONT_MODULE_ID];

// A check uses 2 credits (one per test). The backend takes them only after both videos are analyzed.
export const CREDITS_PER_CHECK = 2;

// About: age 50+, height 4 ft 6 in to 7 ft 0 in.
export const MIN_AGE = 50;
export const MAX_AGE = 110;
export const HEIGHT_MIN_IN = 54;
export const HEIGHT_MAX_IN = 84;

// While a check is analyzing, the person page asks the backend for news this often.
// The phone also gets a push ("Your report is ready") through the existing native notifications.
export const STATUS_POLL_MS = 15000;

export const URLS = {
  terms: "https://seniorlife.ai/terms-of-service/",
  privacy: "https://seniorlife.ai/privacy-data-policy/",
  contact: "https://seniorlife.ai/contact-us/",
  partnerSignup: "https://inochi.seniorlife.ai/signup",
  // A shared report link (/mobility-report-shared/<slug>) for the sample person, made once by ops.
  // Empty = the "See a sample result" buttons are hidden.
  sampleReport: process.env.REACT_APP_PROD_US_SAMPLE_REPORT_URL || "",
};
